<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="发票管理" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="pb-30" v-if="invoice_list.length>0">
            <div v-for="item in invoice_list" :key="item.invoice_id">
                <div class="invoice-item">
                    <div class="top-wrapper">
                        <div v-if="item.invoice_state == 1">
                            <div class="title-wrapper">
                                <label class="title" style="margin-left:0">普通发票</label>
                                <label class="title" >{{ item.invoice_title }}</label>
                            </div>
                            <div class="desc address-text">{{item.invoice_code}}</div>
                        </div>
                        <div v-else>
                            <div class="title-wrapper">
                                <label class="title">增值税发票</label>
                                <label class="title" >{{ item.invoice_company }}</label>
                            </div>
                            <div class="desc address-text">{{item.invoice_company_code}}</div>
                        </div>
                        <div class="bottom-line"></div>
                    </div>
                    <div class="bottom-wrapper">
                        <div class="bottom-left-wrapper" v-if="isFromCheckout">
                            <label class="subtitle" @click="useInvoice(item)">
                                <i v-if="invoice_id == item.invoice_id" class="iconfont">&#xe69d;</i><i v-else class="iconfont">&#xe69e;</i>使用
                            </label>
                        </div>
                        <div class="bottom-right-wrapper">
                            <div class="common-btn btn-2 mr-5" @click="onEdit(item.invoice_id)">编辑</div>
                            <div class="common-btn btn-1" @click="onDelete(item.invoice_id)">删除</div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-if="isFromCheckout">
                <div class="bottom-holder"></div>
                <div class="bottom">
                    <div class="common-btn ds-button-large" @click="useInvoice(false)">不使用发票</div>
                </div>
            </div>
        </div>
        <div  v-else>
            <empty-record></empty-record>
        </div>
		<div class='common-add-btn-wrapper'><div class="div common-btn common-add-btn"  @click="goAdd">新增</div></div>
    </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getInvoiceList, delInvoice } from '../../../api/memberInvoice'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  name: 'InvoiceList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      vat_deny: this.$route.query.vat_deny ? this.$route.query.vat_deny : false,
      isFromCheckout: this.$route.query.isFromCheckout ? this.$route.query.isFromCheckout : false,
      invoice_id: this.$route.query.invoice_id ? this.$route.query.invoice_id : 0,
      invoice_list: []
    }
  },
  created: function () {
    this.getInvoiceList()
  },

  methods: {
    goAdd () {
      this.$router.push({ name: 'MemberInvoiceForm', query: { action: 'add' } })
    },
    useInvoice (item) {
      let query = JSON.parse(this.$route.query.params)
      if (item == false) {
        query.invoice_id = 0
        query.invoice_content = '不需要发票'
      } else {
        let content = ''
        if (this.vat_deny) {
          if (item.invoice_state == 2) {
            Toast('订单商品不支持增值税发票')
            return
          }
        }
        if (item.invoice_state == 2) {
          // content = '增值税发票 ' + item.invoice_company + ' ' + item.invoice_company_code + ' ' + item.invoice_reg_addr
          content = item.invoice_company
        } else {
          // content = '普通发票 ' + item.invoice_title + ' ' + item.invoice_code + ' ' + item.invoice_content
          content = item.invoice_title
        }
        query.invoice_id = item.invoice_id
        query.invoice_content = content
      }
      this.$router.push({ name: 'MemberBuyStep1', query: query })
    },
    onEdit (invoiceId) {
      this.$router.push({ name: 'MemberInvoiceForm', query: { invoice_id: invoiceId } })
    },
    onDelete (invoiceId) {
      Indicator.open()
      delInvoice(invoiceId).then(
        (response) => {
          this.getInvoiceList()
          Indicator.close()
        }, (error) => {
          Indicator.close()
          Toast(error.message)
        })
    },
    getInvoiceList () {
      getInvoiceList().then(res => {
        this.invoice_list = res.result.invoice_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>
<style scoped lang="scss">
    .container{}
    .common-header{
        .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
    }
    .invoice-item{background: #fff;padding:0 $pageSpace;margin-bottom:$modelSpace}
    .btn-1{border:1px solid $primaryColor;color:$primaryColor;min-width: 2rem}
    .btn-2{border:1px solid #333;color:#333;min-width: 2rem}
    .bottom{position:absolute;padding:.5rem $pageSpace;bottom:0;left:0;width:100%;box-sizing: border-box;background: #fff}
    .bottom-holder{height: 3rem;}
    .top-wrapper {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }
    .title-wrapper {
        height: 1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 1rem;
    }
    .title {
        font-size:$h3;
        color: #333;
        margin-left: 0.5rem;
        font-weight: 700;
    }
    .desc {
        color: $descTextColor;
        font-size:$subFontSize;
    }
    .address-text {
        margin-top: 0.5rem;
        margin-bottom: 1rem;
    }
    .bottom-line {
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        border-bottom:1px dashed #eee
    }
    .bottom-wrapper {
        height: 2.5rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: stretch;
        align-items: center;
    }
    .bottom-left-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .bottom-right-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: stretch;
    }
    .edit-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .delete-wrapper {
        margin-right: 0.5rem;
    }
    .subtitle {
        font-size:$subFontSize;
        color: $descTextColor;
    }
    .subtitle i{font-size:$h2;margin-right:.5rem;}
</style>
